import object from '@mailobj-browser/front/js/utils/object.js'

export const audioAndVideo = object(null, {
  audio: true,
  video: true
})

export const audioOnly = object(null, {
  audio: true
})

export const videoOnly = object(null, {
  video: true
})